var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{attrs:{"value":true,"unchecked-value":false,"disabled":true},model:{value:(_vm.model.hasIngredientWithSugarAdded),callback:function ($$v) {_vm.$set(_vm.model, "hasIngredientWithSugarAdded", $$v)},expression:"model.hasIngredientWithSugarAdded"}},[_vm._v(" Mi receta tiene azúcares añadidos. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }